const cpfCnpjFormatter = (conteudo) => {
    if(!conteudo) return null

    if (conteudo.length === 14)
        return conteudo.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    else
        return conteudo.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')

}

export default cpfCnpjFormatter